var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoverageLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 66 65",
    style: {
      enableBackground: "new 0 0 66 65"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F4DFE4;}\n\t.st1{fill:#E1718B;}\n\t.st2{fill:none;}\n\t.st3{fill:#FFF8E0;}\n\t.st4{fill:#EDCE68;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1028",
    transform: "translate(-541 -946.055)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_489",
    transform: "translate(541 946.055)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 32.5,
    cy: 32.5,
    r: 31.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.5,65C14.6,65,0,50.4,0,32.5C0,14.6,14.6,0,32.5,0C50.4,0,65,14.6,65,32.5C65,50.4,50.4,65,32.5,65z  M32.5,2C15.7,2,2,15.7,2,32.5C2,49.3,15.7,63,32.5,63C49.3,63,63,49.3,63,32.5C63,15.7,49.3,2,32.5,2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_490",
    transform: "translate(563 946.055)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 10,
    cy: 32.5,
    rx: 10,
    ry: 32.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10,65C3.5,65,0,48.3,0,32.5C0,16.7,3.5,0,10,0s10,16.7,10,32.5C20,48.3,16.5,65,10,65z M10,2 C6.2,2,2,14.5,2,32.5C2,50.5,6.2,63,10,63c3.8,0,8-12.5,8-30.5C18,14.5,13.8,2,10,2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Line_77"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 546.9,
    y: 961.2,
    className: "st1",
    width: 52.8,
    height: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_78"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 541.4,
    y: 977.7,
    className: "st1",
    width: 64.6,
    height: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_79"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 546.9,
    y: 994.3,
    className: "st1",
    width: 53.6,
    height: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_491",
    transform: "translate(573 949.055)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 17,
    cy: 16.5,
    rx: 16,
    ry: 15.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17,33C7.6,33,0,25.6,0,16.5S7.6,0,17,0s17,7.4,17,16.5S26.4,33,17,33z M17,2C8.7,2,2,8.5,2,16.5 S8.7,31,17,31s15-6.5,15-14.5S25.3,2,17,2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_393",
    transform: "translate(587 954.055)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M3.5,0L3.5,0C5.4,0,7,1.6,7,3.5v15C7,20.4,5.4,22,3.5,22l0,0C1.6,22,0,20.4,0,18.5v-15C0,1.6,1.6,0,3.5,0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.5,22C1.6,22,0,20.4,0,18.5v-15C0,1.6,1.6,0,3.5,0S7,1.6,7,3.5v15C7,20.4,5.4,22,3.5,22z M3.5,2 C2.7,2,2,2.7,2,3.5v15C2,19.3,2.7,20,3.5,20S5,19.3,5,18.5v-15C5,2.7,4.3,2,3.5,2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_394",
    transform: "translate(601.5 961.555) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M3.5,1L3.5,1c1.6,0,2.8,1.4,2.8,3.2v13.6c0,1.8-1.3,3.2-2.8,3.2l0,0c-1.6,0-2.8-1.4-2.8-3.2V4.2 C0.7,2.4,1.9,1,3.5,1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7,3.5v15C7,20.4,5.4,22,3.5,22S0,20.4,0,18.5v-15C0,1.6,1.6,0,3.5,0S7,1.6,7,3.5z M2,18.5 C2,19.3,2.7,20,3.5,20S5,19.3,5,18.5v-15C5,2.7,4.3,2,3.5,2S2,2.7,2,3.5V18.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_395"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M590.5,974.1L590.5,974.1c-0.8,0-1.5-0.7-1.5-1.5v-15c0-0.8,0.7-1.5,1.5-1.5l0,0c0.8,0,1.5,0.7,1.5,1.5v15 C592,973.4,591.3,974.1,590.5,974.1z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoverageLight);
export default __webpack_public_path__ + "static/media/coverage-light.75edbb975faad7834dee795a0d3b66de.svg";
export { ForwardRef as ReactComponent };